<template>
  <div>
    <div v-for="(item, index) in list" :key="index">
      <!-- 模板1 -->
      <div class="pos_r" v-if="item.type === 'formwork1'">
        <img class="w_100p" :src="item.img" />
        <div class="pos_a top_0 z_index_1 w_100p">
          <div class="w_1200 m_lr_auto m_t_220 t_a_c">
            <div class="c_fff f_s_28">{{ item.text1 }}</div>
            <div class="c_fff f_s_40 m_t_20 f_w_600">{{ item.text2 }}</div>
          </div>
        </div>
      </div>
      <!-- 模板2 -->
      <div class="pos_r" v-if="item.type === 'formwork2'">
        <img class="w_100p" :src="item.img" />
      </div>
      <!-- 模板3 -->
      <div class="pos_r" v-if="item.type === 'formwork3'">
        <img class="w_100p" :src="item.img" />
        <div class="pos_a top_0 z_index_1 w_100p">
          <div class="w_1200 m_lr_auto m_t_80 t_a_c">
            <div class="c_fff f_s_18">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <!-- 模板4 -->
      <div class="pos_r" v-if="item.type === 'formwork4'">
        <img class="w_100p" :src="item.img" />
        <div class="pos_a top_0 z_index_1 w_100p">
          <div class="w_1200 m_lr_auto m_t_100">
            <div class="c_fff f_s_30">{{ item.text1 }}</div>
            <div class="c_fff f_s_18 m_t_100">{{ item.text2 }}</div>
          </div>
        </div>
      </div>
      <div class="w_1200 m_lr_auto">
        <!-- 三视图 -->
        <div class="w_1200 h_900 flex" v-if="item.type === 'three-view'">
          <div class="w_590 h_900 b_g_background a_i_c j_c_c flex">
            <img :src="item.imgLeft" class="w_590" />
          </div>
          <div class="w_590 m_l_10">
            <div class="w_590 h_440 b_g_background a_i_c j_c_c flex">
              <img :src="item.imgTop" class="h_440" />
            </div>
            <div class="w_590 h_440 b_g_background m_t_20 a_i_c j_c_c flex">
              <img :src="item.imgFront" class="h_440" />
            </div>
          </div>
        </div>
      </div>
      <!-- 模板5 配件列表-->
      <div class="m_tb_20" v-if="item.type === 'formwork5'">
        <h1 class="t_a_c">Packing list</h1>
        <div class="w_1200 m_lr_auto flex flex_w_w">
          <div class="w_200 t_a_c m_10" v-for="pack in item.packs" :key="pack.id">
            <img :src="pack.img" class="b_c_f8f9fb w_180">
            <div>{{ pack.name }} *{{ pack.num }}</div>
          </div>
        </div>
      </div>

      <!-- 模板6 产品规格-->
      <div class="m_tb_20" v-if="item.type === 'formwork6'">
        <h1 class="t_a_c">Product Specifications</h1>
        <div class="w_1200 m_lr_auto flex flex_w_w">
          <div class="w_50p f_s_12" v-for="specification in item.specifications" :key="specification.id">
            <div class="p_lr_10 p_tb_10">{{ specification.name }}</div>
            <div class="p_lr_10 b_c_baf7c4 p_tb_10 ">{{ specification.value }}</div>
          </div>
        </div>
      </div>

      <!-- 模板7-->
      <div class="m_tb_20" v-if="item.type === 'formwork7'">
        <div class="w_1200 m_lr_auto flex flex_w_w">
          <div class="w_50p f_s_12 flex p_tb_20" v-for="temp in item.list" :key="temp.id">
            <img :src="temp.img" class="b_c_f8f9fb w_120 b_r_100">
            <div class="m_t_30 p_lr_24">{{ temp.label }}</div>
          </div>
        </div>
      </div>

      <!-- 模板8-->
      <div class="m_tb_20" v-if="item.type === 'formwork8'">
        <div class="w_1200 m_lr_auto flex flex_w_w">
          <div class="p_10" v-for="temp in item.list" :key="temp.id">
            <img :src="temp.img" class="b_c_f8f9fb w_360">
          </div>
        </div>
      </div>

      <!-- 模板9-->
      <div class="m_tb_20" v-if="item.type === 'formwork9'">
        <div class="w_1200 m_lr_auto">
          <div class="p_10" v-for="temp in item.list" :key="temp.id">
            {{ temp.text }}
          </div>
        </div>
      </div>

      <!-- 模板10-->
      <div class="m_tb_20" v-if="item.type === 'formwork10'">
        <div class="w_1200 m_lr_auto">
        <div class="w_1200 m_lr_auto flex flex_w_w">
          <div class="w_200 t_a_c m_10" v-for="temp in item.list" :key="temp.id">
            <img :src="temp.img" class="b_c_f8f9fb w_180">
            <div>{{ temp.name }}</div>
          </div>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
/**
 * 产品参数
 */
export default {
  name: "image-text",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style>
.w_266 {
  width: 290px;
}
</style>